<template >
  <v-app style="background: rgba(0,0,0,0);">
    <v-container >
      <v-layout align-center grid-list-md text-xs-center>
          <v-flex xs12 sm10 md8 lg8 class="main" style="margin:0 auto">
		  <div class="title"><h1>OXFORD PERSÖNLICHKEITSTEST</h1></div>

			<v-card color="primary">
			<v-card-title primary-title class="justify-center ma-5">
			<div class="display-1 font-weight-bold white--text">Datenschutzerkl&auml;rung</div>
			</v-card-title>
			</v-card>

            <v-card class="contentwrap">

            <p>Ihre Antworten auf die einzelnen Testfragen werden unmittelbar  nach der Erstellung der Auswertung gelöscht. Ihre Kontaktdaten, Beruf, Alter,  Geschlecht und die Auswertung werden elektronisch an hauptamtlich tätige  Mitglieder der Scientology Gemeinde Baden-Württemberg e.V. übermittelt. Eine  Weitergabe, ein Verkauf oder eine sonstige Übermittlung Ihrer personenbezogenen  Daten an Dritte erfolgt nicht, auch nicht an andere Scientology Organisationen,  es sei denn Sie willigen darin gesondert und ausdrücklich vorher ein.</p>
<p>  Ich erkläre durch meine Einwilligung mein  Einverständnis damit, dass mein Name, meine Adresse, mein Beruf, Alter und  Geschlecht. meine Telefonnummer und E-Mail-Adresse, sowie das Datum meines  Tests und dessen Auswertung von der hier als Absender auftretenden Scientology  Kirche erhoben und in einer Datenverarbeitungsanlage zum Zwecke der  Testauswertung und späteren Missionierung durch Zusendungen von Informationsmaterial  über die Scientology Religion/Kirche gespeichert werden dürfen.<br />
<br />
Ihre oben genannten Daten werden  benötigt, um den Test auszuwerten und Ihnen die Auswertung zur Verfügung  stellen zu können. Die Art und der Umfang an Daten, die Sie durch Ihre  Antworten zur Verfügung stellen, befinden sich vollständig unter Ihrer  Kontrolle. Der Test kann jederzeit unterbrochen oder ganz abgebrochen werden.  Ihre Daten werden nur dann an die Scientology Gemeinde Baden-Württemberg e. V.  geschickt, wenn Sie den Test nach Beendigung absenden. Falls Sie nicht alle  Fragen beantworten möchten, hätte das lediglich zur Folge, dass der Test nicht  vollständig und korrekt ausgewertet werden könnte und dass Sie daher das  Testergebnis und weiterführende Informationen nicht in der Form erhalten  können, wie es ansonsten möglich wäre.</p>
<p>  Die Antworten auf den Test werden von der Scientology Gemeinde  Baden-Württemberg e. V. mit Hilfe eines Computer Programms ausgewertet, welches  das Testergebnis in graphischer Form darstellt.</p>
<p>  Ihre Antworten auf die Testfragen werden unmittelbar nach der Erstellung dieser  graphischen Darstellung gelöscht werden. Lediglich die graphische Darstellung  selbst, Ihr Alter und Geschlecht und Ihre Kontaktdaten werden kurzfristig zur  Verfügung gehalten werden, um Ihnen eine Auswertung zu ermöglichen.</p>
<p>  Qualifizierte hauptamtliche Mitglieder der Scientology Gemeinde  Baden-Württemberg e. V. können Ihnen mit Hilfe der graphischen Darstellung  helfen, sich selbst besser zu verstehen.<br />
<br />
Die graphische Darstellung und Ihre Kontaktdaten sowie Ihre Einwilligung werden  vollständig gelöscht werden, sobald Sie diesen Wunsch der Scientology Gemeinde  Baden-Württemberg e. V. gegenüber äußern, spätestens jedoch nach dreimaligem  Zusenden von Informationsmaterial, falls Sie kein weiteres Interesse an einer  Auswertung des Tests bekundet haben. Ihre Daten werden absolut vertraulich  behandelt und nicht an Dritte weitergegeben, auch nicht an andere  Scientology-Organisationen.</p>
<p>  Ihre Kontaktdaten werden nur verwendet, um Sie über das Testergebnis zu  informieren und Ihnen eine persönliche Auswertung zu ermöglichen. Ihre Daten  werden nicht genutzt, um Sie über andere kirchliche Dienste der Scientology  Gemeinde Baden-Württemberg e.V. zu informieren. Falls Sie weitere Informationen  über solche Dienste wünschen, kontaktieren Sie uns diesbezüglich bitte separat.</p>
<p>Die Verarbeitung der personenbezogenen Daten  erfolgt auf der Rechtsgrundlage nach Art. 6 Abs. 1 lit. a DSGVO mit Ihrer  Einwilligung. Sie können diese Einwilligung jederzeit und mit Wirkung für die  Zukunft widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail oder per  Post (siehe Impressum) an uns. Die Rechtmäßigkeit der bis zum Widerruf  erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt. Ihre Daten  werden anschließend gelöscht, sofern Sie der weitergehenden Verarbeitung und  Nutzung nicht zugestimmt haben. </p>
<h3>Datenschutzhinweise gemäß Artikel 13, 14 und 21 DSGVO</h3>
<p>Hiermit  Informieren wir Sie darüber, wie wir Ihre personenbezogenen Daten verarbeiten  und über die Ansprüche und Rechte, die Ihnen nach rechtlichen Datenschutzregelungen  zustehen.</p>
<p><strong>Verantwortlicher für die  Datenverarbeitung und Empfänger Ihrer Daten<br />
</strong>Scientology  Gemeinde Baden-Württemberg e.V.<strong><br />
  </strong>Heilbronner Str. 67-69, 70191 Stuttgart<br />
Telefon: 0711 / 24 25 36, E-Mail: <a href="mailto:stuttgart@scientology.net">stuttgart@scientology.net</a><br />
<br />
<strong>Kontakt zu unserem  Datenschutzbeauftragten<br />
</strong>Telefon: +4533737777, E-Mail: dpo@scientology.net</p>
<p><strong>Zwecke und rechtliche Grundlagen der  Datenverarbeitung und Dauer der Speicherung<br />
</strong>Schriftliche  Einwilligung. Die Verarbeitung Ihrer personenbezogenen Daten erfolgt, wenn sie  uns eine schriftliche Einwilligung dazu am Ende des Tests gegeben haben, um Ihre  Testdaten auszuwerten und das Ergebnis mit Ihnen bei einem persönlichen Termin  zu besprechen. Solange Ihre Einwilligung vorliegt, werden Ihre  personenbezogenen Daten und Ihre Testauswertung auf Dauer elektronisch auf  lokalen Datenträgern gespeichert. Diese schriftliche Einwilligung kann  jederzeit widerrufen werden.<strong></strong></p>
<p><strong>Rechte der Betroffenen</strong><br />
Sie haben  jederzeit das Recht, Auskunft über die Daten anzufordern, die wir über Sie  gespeichert haben. Zudem können Sie Ihr Recht auf Berichtigung, Löschung und  Einschränkung geltend machen. Darüber hinaus haben Sie das Recht der  Datenübertragbarkeit und des Widerspruchs, wie es unter &quot;Zwecke und  rechtliche Grundlagen der Datenverarbeitung und Dauer der Speicherung&quot;  angegeben ist.<strong></strong></p>
<p><strong>Beschwerderecht bei der  Aufsichtsbehörde</strong><br />
Wenn Sie der  Meinung sind, dass wir Ihre Daten entgegen geltendem Datenschutzrecht  verarbeiten, haben Sie das Recht eine Beschwerde bei der zuständigen  Aufsichtsbehörde für Datenschutz einzureichen.<br />
</p>
<p><strong>Notwendigkeit personenbezogener Daten</strong><br />
Unsere  Dienstleistungen sind grundsätzlich nur gegen Abgabe Ihrer personenbezogenen  Daten (Name, Anschrift, Kontaktmöglichkeiten) möglich.</p>
<p><strong>Widerspruchsrecht</strong><br />
Sofern wir  Ihre personenbezogenen Daten auf Grundlage der Interessenabwägung oder zum  Zwecke der Direktwerbung verarbeiten, haben Sie jederzeit das Recht gegen die  Datenverarbeitung Widerspruch einzulegen. Ihren Widerspruch können Sie uns  formlos zukommen lassen über die Kontaktdaten, die Sie am Anfang dieser  Datenschutzhinweise finden.</p>
<h3>Cookies</h3>
<p>Die  Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf  Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu,  unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies  sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr  Browser speichert.</p>
<p>  Die  meisten der von uns verwendeten Cookies sind so genannte &bdquo;Session-Cookies&ldquo;. Sie  werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf  Ihrem Endgerät gespeichert, bis Sie diese löschen. Diese Cookies ermöglichen es  uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.</p>
<p>  Sie  können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies  informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von  Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische  Löschen der Cookies beim Schließen des Browsers aktivieren. Bei der  Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt  sein.</p>
<h3>Server-Log-Files</h3>
<p>Der  Provider der Seiten erhebt und speichert automatisch Informationen in so  genannten Server-Log Files, die Ihr Browser automatisch an uns übermittelt.  Dies sind:</p>
<ul>
<li>Browsertyp und Browserversion</li>
<li>verwendetes Betriebssystem</li>
<li>Referrer URL</li>
<li>Hostname des zugreifenden Rechners</li>
<li>Uhrzeit der Serveranfrage</li>
</ul>
<p>Diese  Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser  Daten mit anderen Datenquellen wird nicht vorgenommen. Wir behalten uns vor,  diese Daten nachträglich zu prüfen, wenn uns konkrete Anhaltspunkte für eine  rechtswidrige Nutzung bekannt werden.</p>
<h3>Datenschutzerklärung für die Nutzung von Google Analytics</h3>
<p>Diese  Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter  ist die Google Inc., 1600 Amphitheatre Parkway Mountain View, CA 94043, USA.</p>
<p>  Google  Analytics verwendet so genannte &quot;Cookies&quot;. Das sind Textdateien, die  auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der  Website durch Sie ermöglichen. Die durch das Cookie erzeugten Informationen  über Ihre Benutzung dieser Website werden in der Regel an einen Server von  Google in den USA übertragen und dort gespeichert.</p>
<p>  Mehr  Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der  Datenschutzerklärung von Google:  https://support.google.com/analytics/answer/6004245?hl=de</p>
<h3>IP-Anonymisierung</h3>
<p>Wir  nutzen die Funktion &quot;Aktivierung der IP-Anonymisierung&quot; auf dieser  Webseite. Dadurch wird Ihre IP-Adresse von Google jedoch innerhalb von  Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des  Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Nur in  Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA  übertragen und dort gekürzt. Im Auftrag des Betreibers dieser Website wird  Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten,  um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der  Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber  dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem  Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt.</p>
<h3>SSL-Verschlüsselung</h3>
<p>Diese  Seite nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung  vertraulicher Inhalte, wie zum Beispiel der Anfragen, die Sie an uns als  Seitenbetreiber senden, eine SSL-Verschlüsselung. Eine verschlüsselte Verbindung  erkennen Sie daran, dass die Adresszeile des Browsers von &quot;http://&quot;  auf &quot;https://&quot; wechselt und an dem Schloss-Symbol in Ihrer  Browserzeile.</p>
<p>  Wenn  die SSL Verschlüsselung aktiviert ist, können die Daten, die Sie an uns  übermitteln, nicht von Dritten mitgelesen werden.</p>

              </v-card>
            </v-card>
          </v-flex>
      </v-layout>
    </v-container>
    <div class="logo"></div>

    <MyFooter/>
  </v-app>
</template>

<script type="text/javascript">
import MyFooter from '../components/footer.vue'
export default {
  components: {
    MyFooter
  }
}
</script>

<style media="screen">
body {
  background-image: url(background.png);
  background-position: right top;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.container {
    display: table;
}
.logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
	background-image: url(oca-logo.png);
	background-repeat: no-repeat;
	max-width: 250px;
  background-size: contain;
  margin-top: 10px;
  margin-left: 1.5%;
  height: 200px;
  width: 19vw;
}
.introsection2 {
	padding-top: 30px;
    margin-top: 30px;
    padding-left: 50px;
    padding-right: 50px;
    background: #f7f7f7;
}
.ctasection {
    padding: 15px;
}
.v-card {
  overflow:auto;
}
.v-card__title--primary {
    padding-top: 0px;
    padding-bottom: 0px;
}
.v-card__actions {
    padding: 0px;
    background: #fff;
	margin-top: 0px!important;
}
.v-card__actions .xs4 {
    flex-basis: 33.34%!important;
	max-width: 33.34%!important;
}
.v-card__actions .v-sheet {
    border-radius: 0px;
	-webkit-box-shadow: none;
    box-shadow: none;
    text-decoration: none;
}
.yesBtn:hover{
  background-color: rgb(205, 242, 202);
  cursor: pointer;
}
.maybeBtn:hover{
  background-color: rgb(208, 208, 208);
  cursor: pointer;
}
.noBtn:hover{
  background-color: rgb(255, 191, 177);
  cursor: pointer;
}
.main {
    box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.15);
    padding: 0;
}
.main .v-sheet {
	border-radius:0px;
}
.title {
    font-size: 20px!important;
	line-height: 50px!important;
    text-align: left!important;
    padding-left: 20px;
	padding-right: 20px;
    background: #fff;
    font-weight: 400;
}
.title h1 {
    font-size: 20px!important;
	line-height: 50px!important;
    text-align: left!important;
    padding-left: 20px;
	padding-right: 20px;
    background: #fff;
    font-weight: 400;
}
.v-card__text {
    padding: 0;
    line-height: 50px;
}
.progress {
    border-radius: 0 0 0 15px;
	padding: 4px 30px 4px 35px;
    background: #006c9f;
    font-size: 15px!important;
    font-weight: 400!important;
}
.contentwrap {
	padding:40px;
	text-align:left;
}
.contentwrap strong {
	font-weight:600;
}
.contentwrap h3 {
	margin-bottom:15px;
}
</style>
